import * as React from "react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
} from "./dialog"
import { Button } from "./button"

interface ModalProps {
  open?: boolean
  onCancel?: () => void
  onOk?: () => void
  title?: React.ReactNode
  okText?: string
  cancelText?: string
  confirmLoading?: boolean
  children?: React.ReactNode
  footer?: React.ReactNode | null
}

/**
 * Modal component with antd-like API for easier migration
 */
export function Modal({
  open = false,
  onCancel,
  onOk,
  title,
  okText = "OK",
  cancelText = "Cancel",
  confirmLoading = false,
  children,
  footer,
}: ModalProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel?.()}>
      <DialogContent>
        {title && (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
        )}
        <div className="py-2">{children}</div>
        {footer !== null && (
          <DialogFooter>
            {footer !== undefined ? (
              footer
            ) : (
              <>
                <Button variant="link" onClick={onCancel}>
                  {cancelText}
                </Button>
                <Button
                  variant="segment"
                  onClick={onOk}
                  loading={confirmLoading}
                >
                  {okText}
                </Button>
              </>
            )}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  )
}
